import { useTitle } from "@/Utilities/Hooks";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { Inertia } from "@inertiajs/inertia";
import React, { useState } from "react";
import { LabeledInput, ToggleSwitch } from "@/Components/Form";
import { toast } from "react-toastify";
import { Formheader } from "@/Components";
import LayoutIcon from "@/Components/LayoutIcon";
import { Tag as TagsIcon } from "@/Icons";

export default function Create({ errors }) {
  const [tagName, setTagName] = useState("");
  const [inBudget, setInBudget] = useState(false);

  function handleNewCategory() {
    const id = toast.loading("Please wait...");
    Inertia.post(
      "/categories",
      { name: tagName, budget: inBudget },
      {
        onSuccess: () => {
          toast.update(id, {
            render: "The category was successfully created!",
            type: toast.TYPE.SUCCESS,
            isLoading: false,
            autoClose: 5000,
          });
          Inertia.visit("/categories");
        },
        onError: () => {
          toast.update(id, {
            render: "There was an error creating the category",
            type: toast.TYPE.ERROR,
            isLoading: false,
            autoClose: 5000,
          });
        },
      },
    );
  }

  return (
    <>
      <div className="shadow-small flex flex-row flex-wrap bg-gray-light px-8 py-6">
        <div className="w-full">
          <Formheader>Name and create your category</Formheader>
        </div>
        <div className="my-3 w-full">
          <LabeledInput
            title="Name the category"
            type="text"
            placeholder="Name the category"
            value={tagName}
            error={errors && errors.name}
            onChange={(e) => setTagName(e.target.value)}
          />
        </div>
        <div className="my-3 flex w-full content-start items-start">
          <ToggleSwitch
            title="Is this category in your budget?"
            checked={inBudget}
            onChange={(e) => setInBudget(!inBudget)}
          />
          <div className="ml-4">
            <span className="text-md">Show in your CO₂ budget</span>
            <p className="text-sm">
              By checking this box, the activities in which you use this
              category will be visualized in your CO₂ budget.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-4 flex w-full flex-row justify-end gap-4">
        <button
          disabled={tagName === ""}
          className="btn-blue flex-grow-0 px-3 py-4"
          onClick={handleNewCategory}
        >
          Create category
        </button>
      </div>
    </>
  );
}

Create.layout = (page) => (
  <AppLayout title="Create category">
    <OrganizationLayout
      header="New category"
      backAction={{
        label: "Back",
        callback: () => Inertia.visit("/categories"),
      }}
      icon={
        <LayoutIcon>
          <TagsIcon size={40} className="text-black" />
        </LayoutIcon>
      }
    >
      {page}
    </OrganizationLayout>
  </AppLayout>
);
